var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-mobileHeader",class:{
    '-homeHero': _vm.isHomeHero,
    '-withoutStickyHero': _vm.isHomeHero && !_vm.hasAskKeelearningModule,
  },attrs:{"data-cy":"MobileHeader"}},[_c('router-link',{attrs:{"to":{
      name: 'home',
    }}},[(_vm.config.settings.app_logo)?_c('img',{staticClass:"o-mobileHeader__logo",attrs:{"data-cy":"MobileHeader__logo","src":_vm.config.settings.app_logo,"alt":"app logo"}}):_vm._e()]),_c('div',{staticClass:"u-spacer"}),_c('div',{staticClass:"o-mobileHeader__actions"},[(_vm.showChat)?_c('ChatButton',{attrs:{"icon-only":"","small-icon":""}}):_vm._e(),(_vm.avatar)?_c('router-link',{staticClass:"o-mobileHeader__profileAvatar",attrs:{"to":{
        name: 'profile.profile',
      }}},[_c('UserAvatar',{attrs:{"avatar-url":_vm.avatar,"size":32,"show-online-status":"","data-cy":"MobileHeader__avatar"}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }